/****************************************************************
  ActiveCampaign
*****************************************************************/

window.addEventListener("load", function () {
  const footerFormAC = document.querySelector("#footer-ac");
  const inputFields = document.querySelectorAll("._field-wrapper input");
  const labels = document.querySelectorAll("label._form-label");

  if (footerFormAC) {
    inputFields.forEach(function (inputField, index) {
      const label = labels[index];

      if (inputField && label) {
        if (inputField.value.trim() !== "") {
          label.classList.add("focus");
          inputField.classList.add("focus");
        }

        inputField.addEventListener("focus", function () {
          label.classList.add("focus");
          inputField.classList.add("focus");
        });

        inputField.addEventListener("blur", function () {
          if (inputField.value.trim() === "") {
            label.classList.remove("focus");
            inputField.classList.remove("focus");
          }
        });
      }
    });
  }
});

// /****************************************************************
//   Cart Drawer - Hide Checkout Until Accepting Terms of Sale


// document.addEventListener("DOMContentLoaded", function () {
//   const cartDrawer = document.querySelector("#CartDrawer");

//   // Initialize Cart Drawer behavior
//   function initializeCartDrawer() {
//     const mainTermsCheckbox = document.querySelector("#main-terms-checkbox");
//     const drawerInnerOverlay = document.querySelector(".drawer__inner-overlay");
//     const cartDrawer = document.querySelector(".cart-drawer");
//     const termsCheckbox = document.getElementById("terms-content-checkbox");
//     const termsContentLabel = document.querySelector("#terms-content-label");
//     const footerButtons = document.querySelector(".ultra-payment-buttons");
//     const termsContent = document.getElementById("terms-content");
//     const checkoutBtn = document.querySelector(".checkout-button");
//     const progressBar = document.querySelector(".terms-bar");
//     const termsWrapper = document.querySelector(".terms-content-wrapper");

//     if (!mainTermsCheckbox || !termsCheckbox || !termsContent) {
//       console.warn(
//         "Required elements (mainTermsCheckbox, termsCheckbox, termsContent) not found. Skipping initialization."
//       );
//       return;
//     }

//     console.log("Initializing Cart Drawer...");

//     // Avoid reattaching listeners if already initialized
//     if (!mainTermsCheckbox.dataset.listenerAdded) {
//       mainTermsCheckbox.addEventListener("click", function () {
//         console.log("Main terms checkbox clicked!");
//         mainTermsCheckbox.classList.toggle("clicked");
//         termsContent.classList.toggle("show");
//       });

//       mainTermsCheckbox.dataset.listenerAdded = true;
//     }

//     if (!termsCheckbox.dataset.listenerAdded) {
//       termsCheckbox.addEventListener("click", function () {
//         console.log("Terms checkbox clicked!");

//         const isChecked = termsCheckbox.classList.contains("checked");

//         drawerInnerOverlay.classList.toggle("active");
//         cartDrawer.classList.toggle("not-active");

//         // Cart Drawer
//         toggleClass(termsCheckbox, "checked", !isChecked);
//         toggleClass(termsContentLabel, "checked", !isChecked);
//         toggleClass(footerButtons, "not-active", isChecked);
//         toggleClass(termsContent, "show", isChecked);

//         mainTermsCheckbox.classList.toggle("checked", !isChecked);

//         isChecked
//           ? checkoutBtn.setAttribute("disabled", true)
//           : checkoutBtn.removeAttribute("disabled");
//       });

//       termsCheckbox.dataset.listenerAdded = true;
//     }

//     // Initialize progress bar for terms content
//     if (progressBar && termsWrapper) {
//       console.log("Initializing Terms Progress...");

//       termsWrapper.addEventListener("scroll", function () {
//         const scrollHeight =
//           termsWrapper.scrollHeight - termsWrapper.clientHeight;
//         const scrolled = termsWrapper.scrollTop;

//         // Calculate the progress percentage
//         const progress = Math.min((scrolled / scrollHeight) * 100, 100);

//         // Update the progress bar's width
//         progressBar.style.width = `${progress}%`;
//       });
//     }
//   }

//   // Helper function to toggle classes
//   function toggleClass(element, className, condition) {
//     condition
//       ? element.classList.add(className)
//       : element.classList.remove(className);
//   }

//   // Observer to detect changes in the Cart Drawer
//   function observeCartDrawer() {
//     if (!cartDrawer) {
//       console.error("CartDrawer not found");
//       return;
//     }

//     const observer = new MutationObserver((mutationsList) => {
//       for (const mutation of mutationsList) {
//         if (mutation.type === "childList" || mutation.type === "subtree") {
//           console.log("Cart Drawer updated. Reinitializing...");
//           initializeCartDrawer(); // Reinitialize logic when Cart Drawer updates
//         }
//       }
//     });

//     observer.observe(cartDrawer, { childList: true, subtree: true });
//   }

//   // Initialize everything
//   initializeCartDrawer(); // First-time initialization
//   observeCartDrawer(); // Observe Cart Drawer for updates
// });
// */



// /****************************************************************
//   Utility Functions for Local Storage - Added
// *****************************************************************/
//   function setTermsCheckboxState(state) {
//     const oneWeek = 7 * 24 * 60 * 60 * 1000; // 1 week in milliseconds
//     const expiry = new Date().getTime() + oneWeek;
//     localStorage.setItem('termsCheckboxState', JSON.stringify({ state, expiry }));
//   }

//   function getTermsCheckboxState() {
//     const item = localStorage.getItem('termsCheckboxState');
//     if (!item) return null;

//     const { state, expiry } = JSON.parse(item);
//     if (new Date().getTime() > expiry) {
//       localStorage.removeItem('termsCheckboxState');
//       return null;
//     }

//     return state;
//   }

//   /****************************************************************
//     Apply Stored State from Local Storage - NEW
//   *****************************************************************/
//   function applyTermsState() {
//     const termsCheckbox = document.getElementById("terms-content-checkbox");
//     const checkoutBtn = document.querySelector(".checkout-button");
//     const footerButtons = document.querySelector(".ultra-payment-buttons");
//     const mainTermsCheckbox = document.querySelector("#main-terms-checkbox");
//     const termsContentLabel = document.querySelector("#terms-content-label");
//     const termsContent = document.getElementById("terms-content");
//     const cartOverlay = document.getElementById("cart-overlay");

//     if (termsContentLabel.classList.contains("checked"))
//       termsCheckbox.classList.add("checked");

//     const storedState = getTermsCheckboxState();
//     if (storedState !== null) {
//       termsCheckbox.checked = storedState;

//       if (storedState) {
//         // Add necessary classes when state is true
//         checkoutBtn.removeAttribute("disabled");
//         footerButtons.classList.add("pre-active");
//         footerButtons.classList.remove("not-active");
//         mainTermsCheckbox.classList.add("checked", "clicked");
//         termsContent.classList.add("show");
//         termsContentLabel.classList.add("checked");

//         // Remove 'active' class from cart-overlay when state is true
//         if (cartOverlay) cartOverlay.classList.remove("active");
//       } else {
//         // Remove classes when state is false
//         checkoutBtn.setAttribute("disabled", true);
//         footerButtons.classList.remove("pre-active");
//         footerButtons.classList.add("not-active");
//         mainTermsCheckbox.classList.remove("checked", "clicked");
//         termsContent.classList.remove("show");
//         termsContentLabel.classList.remove("checked");

//         // Add 'active' class to cart-overlay when state is false
//         if (cartOverlay) cartOverlay.classList.add("active");
//       }
//     }
//   }



// /****************************************************************
//   Cart Drawer - Hide Checkout Until Accepting Terms of Sale
// *****************************************************************/

// document.addEventListener("DOMContentLoaded", function () {
//   const cartDrawer = document.querySelector("#CartDrawer");

//   // Ensure we're in the Cart Drawer
//   if (!cartDrawer) return;

//   applyTermsState(); // Apply stored state on page load

//   function initializeCartDrawer() {
//     const mainTermsCheckbox = document.querySelector("#main-terms-checkbox");
//     const drawerInnerOverlay = document.querySelector(".drawer__inner-overlay");
//     const cartDrawer = document.querySelector(".cart-drawer");
//     const termsCheckbox = document.getElementById("terms-content-checkbox");
//     const termsContentLabel = document.querySelector("#terms-content-label");
//     const footerButtons = document.querySelector(".ultra-payment-buttons");
//     const termsContent = document.getElementById("terms-content");
//     const checkoutBtn = document.querySelector(".checkout-button");
//     const progressBar = document.querySelector(".terms-bar");
//     const termsWrapper = document.querySelector(".terms-content-wrapper");

//     if (!mainTermsCheckbox || !termsCheckbox || !termsContent) {
//       console.warn(
//         "Cart Drawer: Required elements (mainTermsCheckbox, termsCheckbox, termsContent) not found. Skipping."
//       );
//       return;
//     }

//     console.log("Initializing Cart Drawer...");

//     if (!mainTermsCheckbox.dataset.listenerAdded) {
//       mainTermsCheckbox.addEventListener("click", function () {
//         console.log("Cart Drawer: Main terms checkbox clicked!");
//         mainTermsCheckbox.classList.toggle("clicked");
//         termsContent.classList.toggle("show");
//       });

//       mainTermsCheckbox.dataset.listenerAdded = true;
//     }

//     if (!termsCheckbox.dataset.listenerAdded) {

//       termsCheckbox.addEventListener("click", function () {

//         console.log("Cart Drawer: Terms checkbox clicked!");

//         // ✅ Check if termsContent already has the "show" class
//         const wasContentVisible = termsContent.classList.contains("show");

//         // ✅ Toggle "checked" class on checkbox
//         termsCheckbox.classList.toggle("checked");

//         // ✅ Get the updated state AFTER toggling
//         const isChecked = termsCheckbox.classList.contains("checked");

//         // ✅ Store updated state in Local Storage
//         setTermsCheckboxState(isChecked);

//         // ✅ Update other elements based on the new state
//         drawerInnerOverlay.classList.toggle("active", isChecked);
//         cartDrawer.classList.toggle("not-active", isChecked);
//         toggleClass(termsContentLabel, "checked", isChecked);
//         toggleClass(termsCheckbox, "checked", isChecked);
//         toggleClass(footerButtons, "not-active", !isChecked);

//         // ✅ Ensure "show" class is toggled correctly based on previous state
//         if (!wasContentVisible) {
//           termsContent.classList.add("show");
//           drawerInnerOverlay.classList.add("active");
//         } else if (wasContentVisible ) {
//           termsContent.classList.remove("show");
//           drawerInnerOverlay.classList.remove("active");
//           cartDrawer.classList.remove("not-active");
//         }

//         toggleClass(mainTermsCheckbox, "checked", isChecked);

//         // ✅ Enable/Disable Checkout button based on new state
//         if (isChecked) {
//           checkoutBtn.removeAttribute("disabled");
//         } else {
//           checkoutBtn.setAttribute("disabled", true);
//         }
//       });

//       termsCheckbox.dataset.listenerAdded = "true";
//     }

//     if (progressBar && termsWrapper) {
//       console.log("Cart Drawer: Initializing Terms Progress...");

//       termsWrapper.addEventListener("scroll", function () {
//         const scrollHeight =
//           termsWrapper.scrollHeight - termsWrapper.clientHeight;
//         const scrolled = termsWrapper.scrollTop;

//         const progress = Math.min((scrolled / scrollHeight) * 100, 100);
//         progressBar.style.width = `${progress}%`;
//       });
//     }
//   }

//   function observeCartDrawer() {
//     if (!cartDrawer) {
//       console.error("Cart Drawer not found");
//       return;
//     }

//     const observer = new MutationObserver((mutationsList) => {
//       for (const mutation of mutationsList) {
//         if (mutation.type === "childList" || mutation.type === "subtree") {
//           console.log("Cart Drawer: Updated. Reinitializing...");
//           initializeCartDrawer();
//         }
//       }
//     });

//     observer.observe(cartDrawer, { childList: true, subtree: true });
//   }

//   function toggleClass(element, className, condition) {
//     if (!element) return;
//     condition
//       ? element.classList.add(className)
//       : element.classList.remove(className);
//   }

//   initializeCartDrawer();
//   observeCartDrawer();
// });



// /****************************************************************
//   Cart Page - Hide Checkout Until Accepting Terms of Sale
// *****************************************************************/

// document.addEventListener("DOMContentLoaded", function () {
//   // Ensure we're on the Cart Page
//   if (!document.body.classList.contains("template-cart")) return;

//   applyTermsState(); // Apply stored state on page load

//   function initializeCartPage() {
//     const cartOverlay = document.querySelector("#cart-overlay");
//     const mainTermsCheckbox = document.querySelector("#main-terms-checkbox");
//     const termsCheckbox = document.getElementById("terms-content-checkbox");
//     const termsContentLabel = document.querySelector("#terms-content-label");
//     const checkoutBtn = document.querySelector(".checkout-button");
//     const footerButtons = document.querySelector(".ultra-payment-buttons");
//     const termsContent = document.getElementById("terms-content");
//     const progressBar = document.querySelector(".terms-bar");
//     const termsWrapper = document.querySelector(".terms-content-wrapper");

//     if (!mainTermsCheckbox || !termsCheckbox || !termsContent) {
//       console.warn(
//         "Cart Page: Required elements (mainTermsCheckbox, termsCheckbox, termsContent) not found. Skipping."
//       );
//       return;
//     }

//     console.log("Initializing Cart Page...");

//     if (!mainTermsCheckbox.dataset.listenerAdded) {
//       mainTermsCheckbox.addEventListener("click", function () {
//         console.log("Cart Page: Main terms checkbox clicked!");
//         mainTermsCheckbox.classList.toggle("clicked");
//         termsContent.classList.toggle("show");
//         footerButtons.classList.toggle("pre-active");
//       });

//       mainTermsCheckbox.dataset.listenerAdded = true;
//     }

//     if (!termsCheckbox.dataset.listenerAdded) {
//       termsCheckbox.addEventListener("click", function () {
//         console.log("Cart Page: Terms checkbox clicked!");

//         const isChecked = termsCheckbox.checked;

//         setTermsCheckboxState(isChecked); // Store in Local Storage when clicked

//         cartOverlay.classList.toggle("active");

//         toggleClass(termsCheckbox, "checked", isChecked);
//         toggleClass(termsContentLabel, "checked", isChecked);
//         toggleClass(footerButtons, "not-active", !isChecked);
//         toggleClass(termsContent, "show", isChecked);
//         toggleClass(mainTermsCheckbox, "checked", isChecked);

//         if (isChecked) {
//           checkoutBtn.removeAttribute("disabled");
//         } else {
//           checkoutBtn.setAttribute("disabled", true);
//         }
//       });

//       termsCheckbox.dataset.listenerAdded = true;
//     }

//     if (progressBar && termsWrapper) {
//       console.log("Cart Page: Initializing Terms Progress...");

//       termsWrapper.addEventListener("scroll", function () {
//         const scrollHeight =
//           termsWrapper.scrollHeight - termsWrapper.clientHeight;
//         const scrolled = termsWrapper.scrollTop;

//         const progress = Math.min((scrolled / scrollHeight) * 100, 100);
//         progressBar.style.width = `${progress}%`;
//       });
//     }
//   }

//   function toggleClass(element, className, condition) {
//     if (!element) return;
//     condition
//       ? element.classList.add(className)
//       : element.classList.remove(className);
//   }

//   initializeCartPage();
// });



// /****************************************************************
//   Will run for Cart Drawer and Cart Page
// *****************************************************************/

// document.addEventListener("DOMContentLoaded", function () {

//   console.log("Terms of Sale script initialized.");

//   // Fallback if localStorage fails
//   let termsStateFallback = null;

//   function setTermsCheckboxState(state) {
//     try {
//       const oneWeek = 7 * 24 * 60 * 60 * 1000;
//       const expiry = Date.now() + oneWeek;
//       localStorage.setItem(
//         "termsCheckboxState",
//         JSON.stringify({ state, expiry })
//       );
//     } catch (e) {
//       console.warn("LocalStorage not available, using fallback.");
//       termsStateFallback = {
//         state,
//         expiry: Date.now() + 7 * 24 * 60 * 60 * 1000,
//       };
//     }
//   }

//   function getTermsCheckboxState() {
//     try {
//       const item = localStorage.getItem("termsCheckboxState");
//       if (!item) return termsStateFallback ? termsStateFallback.state : null;

//       const { state, expiry } = JSON.parse(item);
//       if (Date.now() > expiry) {
//         localStorage.removeItem("termsCheckboxState");
//         return null;
//       }
//       return state;
//     } catch (e) {
//       console.warn("Error accessing localStorage, using fallback.");
//       return termsStateFallback ? termsStateFallback.state : null;
//     }
//   }

//   function applyTermsState() {
//     console.log("Applying terms state...");

//     const cartDrawer = document.querySelector(".cart-drawer");
//     const termsCheckbox = document.getElementById("terms-content-checkbox");
//     const checkoutBtn = document.querySelector(".checkout-button");
//     const footerButtons = document.querySelector(".ultra-payment-buttons");
//     const mainTermsCheckbox = document.querySelector("#main-terms-checkbox");
//     const termsContentLabel = document.querySelector("#terms-content-label");
//     const termsContent = document.getElementById("terms-content");
//     const cartOverlay = document.getElementById("cart-overlay");

//     const storedState = getTermsCheckboxState();
//     console.log("Stored terms state:", storedState);

//     if (termsContentLabel.classList.contains("checked"))
//       termsCheckbox.classList.add("checked");

//     if (storedState === null) return;

//     termsCheckbox.checked = storedState;

//     if (storedState) {
//       console.log("Enforcing accepted terms state.");
//       checkoutBtn?.removeAttribute("disabled");
//       footerButtons?.classList.add("pre-active");
//       footerButtons?.classList.remove("not-active");
//       mainTermsCheckbox?.classList.add("checked", "clicked");
//       termsContent?.classList.remove("show");
//       termsContentLabel?.classList.add("checked");
//       cartOverlay?.classList.remove("active");
//       cartDrawer.classList.add("terms-ready");
//       cartDrawer.classList.remove("not-active");
//     } else {
//       console.log("Enforcing not accepted terms state.");
//       checkoutBtn?.setAttribute("disabled", true);
//       footerButtons?.classList.remove("pre-active");
//       footerButtons?.classList.add("not-active");
//       mainTermsCheckbox?.classList.remove("checked", "clicked");
//       termsContent?.classList.remove("show");
//       termsContentLabel?.classList.remove("checked");
//       cartOverlay?.classList.add("active");
//       cartDrawer.classList.remove("terms-ready");
//       cartDrawer.classList.add("not-active");
//     }
//   }

//   // Listen for cart updates from Shopify
//   document.addEventListener("cart:updated", function () {
//     console.log("Cart updated detected by Shopify event.");
//     applyTermsState();
//   });

//   // Observer for fallback detection of cart changes
//   const observer = new MutationObserver(() => {
//     console.log("Cart DOM mutation observed.");
//     applyTermsState();
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

//   applyTermsState();
// });
